<template>
  <div>
    <el-tabs
      v-model="activeName"
      :tab-position="screenWidth > 1023 ? 'left' : 'top'"
    >
      <el-tab-pane
        name="product_description"
        v-if="p('Products.Product Description.View')"
      >
        <div class="left-tab-label" slot="label">
          <div class="label-title">
            {{ $t('text.product_description') }}
          </div>
          <div class="label-desc">
            {{ $t('text.general_product_description') }}
          </div>
        </div>
        <ProductList v-if="activeName === 'product_description'" />
      </el-tab-pane>
      <el-tab-pane
        name="product_characteristics"
        v-if="p('Products.Product Characteristics.View')"
      >
        <div class="left-tab-label" slot="label">
          <div class="label-title">
            {{ $t('text.product_characteristics') }}
          </div>
          <div class="label-desc">
            {{ $t('text.product_characterise_properties') }}
          </div>
        </div>
        <ProductCharacteristics
          v-if="activeName === 'product_characteristics'"
        />
      </el-tab-pane>
      <el-tab-pane
        name="run_product_characteristics"
        v-if="p('Products.Product Characteristics.View')"
      >
        <div class="left-tab-label" slot="label">
          <div class="label-title">
            Run Product Characteristics
          </div>
          <div class="label-desc">
            {{ $t('text.product_characterise_properties') }}
          </div>
        </div>
        <RunProductCharacteristics
          v-if="activeName === 'run_product_characteristics'"
        />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import $ from 'jquery'
import ProductList from '@/components/products/products/ProductList'
import ProductCharacteristics from '@/components/products/products/ProductCharacteristics'
import RunProductCharacteristics from '@/components/products/products/RunProductCharacteristics'
export default {
  data() {
    return {
      activeName: 'product_description',
      screenWidth: window.innerWidth
    }
  },
  components: {
    ProductList,
    ProductCharacteristics,
    RunProductCharacteristics
  },
  mounted: function() {
    this.activeName = this.$permission('Products.Product Description.View')
      ? 'product_description'
      : 'product_characteristics'
    window.addEventListener('resize', this.getScreenWidth)
    setTimeout(() => {
      this.toggleNavArrow()
      if (this.screenWidth <= 1023) {
        this.listenNavBtnClick()
      }
    }, 50)
  },
  watch: {
    activeName() {
      this.toggleNavArrow()
    }
  },
  methods: {
    listenNavBtnClick() {
      var nextBtn = document.getElementsByClassName('el-tabs__nav-next')
      nextBtn[0].addEventListener(
        'click',
        function() {
          $('.el-tabs__nav-next').hide()
          $('.el-tabs__nav-prev').show()
        },
        true
      )
      var prevBtn = document.getElementsByClassName('el-tabs__nav-prev')
      prevBtn[0].addEventListener(
        'click',
        function() {
          $('.el-tabs__nav-prev').hide()
          $('.el-tabs__nav-next').show()
        },
        true
      )
    },
    toggleNavArrow() {
      if (this.activeName === 'product_characteristics') {
        $('.el-tabs__nav-next').hide()
      } else {
        $('.el-tabs__nav-next').show()
      }
      if (this.activeName === 'product_description') {
        $('.el-tabs__nav-prev').hide()
      } else {
        $('.el-tabs__nav-prev').show()
      }
    },
    getScreenWidth() {
      this.screenWidth = window.innerWidth
    }
  }
}
</script>
